import { MultiSelectControl, MultiSelectControlProps } from "@dgs/core";
import { ComponentType } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { AttributeType } from "./analyticsTypes";

const options: AttributeType[] = [
	AttributeType.eventType,
	AttributeType.organizationalUnits,
	AttributeType.industries,
	AttributeType.organizer,
	AttributeType.format,
	AttributeType.category,
	AttributeType.targetGroup,
	AttributeType.region,
	AttributeType.tags,
];

type AttributeMultiSelectControlProps = MultiSelectControlProps<AttributeType, AttributeType>;

const StyledControl = styled(MultiSelectControl as ComponentType<AttributeMultiSelectControlProps>)`
	padding-bottom: 0;
`;

export function EventAnalyticsAttributeMultiSelectControl(
	props: Omit<MultiSelectControlProps<AttributeType, AttributeType>, "options" | "clearable" | "onClear">,
) {
	const { t } = useTranslation();

	return (
		<StyledControl
			{...props}
			getLabel={(o: AttributeType) => t(o)}
			options={options}
			clearable={false}
			onClear={undefined}
		/>
	);
}
